/**
 * Every question of a finished quiz: the learner's answer, the correct
 * answer and the explanation. Shown on the results screen and again when a
 * saved quiz is reopened from My Progress.
 */
import { MathText } from "./Math";
import type { QuizReviewItem } from "../types";

export function QuizReviewList({ items }: { items: QuizReviewItem[] }) {
  if (items.length === 0) return null;
  return (
    <div className="quiz-review" aria-label="Quiz review">
      {items.map((item, i) => (
        <article key={`${item.question.id}-${i}`} className="quiz-review-item">
          <div className="quiz-review-head">
            <span>Question {i + 1}</span>
            <strong className={item.is_correct ? "quiz-review-correct" : "quiz-review-incorrect"}>
              {item.is_correct ? "Correct" : "Not quite"} · {Math.round(item.score * 100)}%
            </strong>
          </div>
          <div className="quiz-review-question">
            <MathText content={item.question.text} />
          </div>
          <p>
            <strong>Your answer:</strong>{" "}
            {item.response_text || (item.handwritten ? "(handwritten)" : "")}
            {item.response_text && item.handwritten ? " (plus handwriting)" : ""}
          </p>
          {item.correct_answer && (
            <p><strong>Correct answer:</strong> {item.correct_answer}</p>
          )}
          <div className="quiz-review-explanation">
            <MathText content={item.explanation} />
          </div>
        </article>
      ))}
    </div>
  );
}
